<template>
<v-row>
  <!-- <v-col cols="12" >
    <v-breadcrumbs :items="crumbs" />
  </v-col> -->
  <v-col cols="4" >
    <team-sidebar
      v-if="businessId"
      :business-id="businessId"
      :touch="touchSidebar" />
    <v-skeleton-loader v-else
      type="card-avatar, article, article, article" />
  </v-col>
  <v-col cols="8" >
    <router-view @saved="touchSidebar++" />
  </v-col>
</v-row>
</template>
<script>
import TeamSidebar from "./TeamSidebar.vue"
export default {
  name: 'Team',
  components: {TeamSidebar},
  data () {
    return {
      touchSidebar: 0
    }
  },
  methods: {
    saved () {
      this.touchSidebar++
    }
  },
  computed: {
    businessId () { return this.calculatedBusinessId }
  }
}
</script>
